"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToClosestValue = roundToClosestValue;
function roundToClosestValue(valueToRound, roundingNumber = 10) {
    if (!valueToRound) {
        return null;
    }
    return Math.round(valueToRound / roundingNumber) * roundingNumber;
}
